module.exports = __webpack_public_path__ + "static/6-37fb1fc3a088bb945d6604ca69e50d88.jpg";